// src/components/Layout.js
import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';

function Layout() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const location = useLocation();

  // Hide sidebar for specific routes
  useEffect(() => {
    // Specify the routes where you want to hide the sidebar
    if (location.pathname.includes('/clients/create') || location.pathname.includes('/clients/edit')) {
      setIsSidebarVisible(false);
    } else {
      setIsSidebarVisible(true);
    }
  }, [location.pathname]);

  return (
    <div className="layout">
      {/* Pass isVisible prop to Sidebar */}
      <Sidebar isVisible={isSidebarVisible} />
      <main>
        <Outlet /> {/* This renders the matching route's component */}
      </main>
    </div>
  );
}

export default Layout;